import React from 'react';
import { useNavigate, useParams } from 'react-router-dom'; 
import MantineButton from '../../components/mantine/button';
import MantineGroup from '../../components/mantine/group';

const LogoutConfirmation = ({ modalclose, currentPrimaryColor}: any) => {
    const navigate = useNavigate();
    const logout = () => {
        localStorage.clear();
        navigate('/');
    };
    
    return (
        <div className="text-center">
            <strong style={{ fontSize: '14px' }}>
                Are you sure you want to logout?
            </strong>

            <MantineGroup position="right" className="mt-6 justify-end">
                <MantineButton name={'Cancel'} onClick={modalclose} className={"bg-secondary_color hover:bg-hover_secondary_btn mt-[15px] text-sm font-thin !w-[100px] "} >Cancel</MantineButton>
                <MantineButton name={'Yes'} className={"mt-[15px] text-sm font-thin !w-[90px] mr-3"} color={currentPrimaryColor} onClick={logout}>Yes</MantineButton>

            </MantineGroup>
        </div>

    );
};

export default LogoutConfirmation;



